export default __webpack_public_path__ + "static/media/Cardo-Regular.a5c741a3.woff2";